<template>
  <div style="height:91vh" @click="goback">
    <error-content code="404" desc="~~点击返回~" :src="src"/>
  </div>
 
</template>

<script>
import error404 from '@/assets/error-page/error-404.svg'
import errorContent from './error-content.vue'
export default {
  name: 'error_404',
  components: {
    errorContent
  },
  data () {
    return {
      src: error404
    }
  },
  created(){
    setTimeout(()=>{
      this.$router.go(-1)
    },2000)
  },
  methods:{
    goback(){
       this.$router.go(-1)
    }
  }
}
</script>
